import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";

export const UserOrderHeader = () => {
  return (
    <thead>
      <TableRowHeader>
        <TableCellHeaderText className="pl-3">Order ID</TableCellHeaderText>
        <TableCellHeaderText>Restaurant</TableCellHeaderText>
        <TableCellHeaderText>Time of order</TableCellHeaderText>
        <TableCellHeaderText>Order type</TableCellHeaderText>
        <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
          Order status
        </TableCellHeaderText>
        <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
          Total price
        </TableCellHeaderText>
      </TableRowHeader>
    </thead>
  );
};
